import { ComponentPropsWithRef, ComponentType, ExoticComponent, lazy } from "react";

type TLazyExoticComponent<T extends ComponentType<any>> = ExoticComponent<ComponentPropsWithRef<T>> & {
  readonly _result: T;
};

export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
): TLazyExoticComponent<T> {
  //@ts-ignore
  return lazy(async () => {
    const isThirdParty = !!document?.getElementById("perlasgo-third-party-attached");
    //todo - think how to solve this for third party as we cant access localStorage from iframe
    let pageHasAlreadyBeenForceRefreshed = false;
    if (!isThirdParty) {
      pageHasAlreadyBeenForceRefreshed = JSON.parse(
        window.localStorage.getItem("page-has-been-force-refreshed") || "false"
      );
    }

    try {
      const component = await componentImport();

      if (!isThirdParty) {
        window.localStorage.setItem("page-has-been-force-refreshed", "false");
      }

      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        if (!isThirdParty) {
          window.localStorage.setItem("page-has-been-force-refreshed", "true");
          return window.location.reload();
        }
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });
}
